import script from "./TheSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSignup.vue?vue&type=script&setup=true&lang=js"

import "./TheSignup.vue?vue&type=style&index=0&id=2858dd59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2858dd59"]])

export default __exports__